import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { createContext } from 'react';
import { Fetch } from '../services/NetworkService';
import { TracingHeaders } from '../services/tracingHeaders';
import { env } from '../util/env';
import generatedFragmentMatcher from './hannibal/fragment-matcher.generated.json';

export const makeGqlContext = () => createContext<NormalClient | undefined>(undefined);

export type NormalClient = ApolloClient<NormalizedCacheObject>;

export const makeApolloClient = (
  fetch: Fetch,
  uri: string,
  cacheData?: NormalizedCacheObject | null,
  headers?: TracingHeaders,
): NormalClient => {
  const cache = new InMemoryCache({
    possibleTypes: generatedFragmentMatcher.possibleTypes,
    typePolicies: {
      Practice: {
        fields: {
          address: {
            merge: true,
          },
        },
      },
    },
  });

  if (cacheData) cache.restore(cacheData);

  const link = new HttpLink({
    uri,
    fetch,
    headers,
    includeExtensions: true,
  });

  return new ApolloClient({
    cache,
    connectToDevTools: process.browser,
    link,
    name: process.browser ? 'unicron-browser' : 'unicron',
    ssrMode: !process.browser,
    version: env.COMMIT_SHA,
  });
};
